import React, { Component } from 'react';
import { connect } from "react-redux";
import { CallbackComponent } from "redux-oidc";
import { push } from "connected-react-router";
import userManager from "../userManager";

class CallbackPage extends React.Component{
  render() {
    return (
      <CallbackComponent
        userManager={userManager}
        successCallback={(user) => this.props.dispatch(push(user.state.path.replace(process.env.PUBLIC_URL, '')))}
        errorCallback={error => {
          this.props.dispatch(push(''));
          console.error(error);
        }}
      >
        <div>Redirecting...</div>
      </CallbackComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.oidc.user
  };
}

export default connect(mapStateToProps)(CallbackPage);